import { useState, useEffect } from 'react';

import Cookies from 'js-cookie';

import wwwapi from '@lcsc-ui/asyncApi/home';
import useUserStore from '@lcsc-ui/store/user';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import Domains from '@lcsc-ui/utils/domains';
import sendAxios from '@lcsc-ui/utils/request';

const IndexTopBanner = ({ setFaterBannerResult, isNeedTopAd, needMb = false }) => {
  const [topBanner, setTopBanner] = useState([]);
  const [bannerResult, setBannerResult] = useState(null);
  const [topBannerShow, setTopBannerShow] = useState(false);
  const [topBannerIdx, setTopBannerIdx] = useState(-1);
  const { userInfo } = useUserStore();

  async function fecthData() {
    const { result } = await sendAxios({
      method: 'get',
      url: wwwapi.indexTopBanner,
      baseURL: Domains.lcscOpUrl,
    });
    setBannerResult(result);
    setTopBannerIdx(-1);
    if (result?.some((tb) => tb.backgroundLeftUrl)) {
      setFaterBannerResult && setFaterBannerResult(true);
      setTopBannerIdx(0);
    }
  }

  useEffect(() => {
    setTopBannerShow(!Cookies.get('AdvertisingNotShow'));
    try {
      fecthData();
    } catch (error) {
      console.error(error);
    }
  }, [userInfo?.isUserLogin]);

  useEffect(() => {
    if (bannerResult?.length > 0) {
      let timeoutId;
      if (bannerResult.some((tb) => tb.backgroundLeftUrl)) {
        setTopBanner([bannerResult.find((tb) => tb.backgroundLeftUrl)]);
        if (location?.pathname === '/index' || location?.pathname === '/') {
          setTopBannerShow(true);
        }
      } else {
        setTopBanner(bannerResult);
        const updateBannerIdx = () => {
          setTopBannerIdx((prevIdx) => (prevIdx + 1) % bannerResult.length); // 假设共有 5 个 banner
          timeoutId = setTimeout(updateBannerIdx, 5000); // 每隔 5 秒更新一次
        };
        updateBannerIdx(); // 立即执行一次
      }

      return () => {
        clearTimeout(timeoutId); // 清除定时器，避免内存泄漏
      };
    }
  }, [bannerResult]);

  function topBannerBuriedPoint(ck = 'close') {
    buriedPoint({
      cp: 'top_header',
      ty: 'click',
      op: 'top_banner',
      data: {
        hf: topBanner[topBannerIdx]?.targetLink,
        ck,
      },
    });
  }

  function closeTopBanner() {
    topBannerBuriedPoint();
    Cookies.set('AdvertisingNotShow', true, {
      domain: '.szlcsc.com',
    });
    setTopBannerShow(false);
  }

  function handleClickTopBanner() {
    topBannerBuriedPoint('open');
  }
  if (!topBannerShow || !bannerResult) {
    return <></>;
  }
  let currentTb;
  if (topBanner.length) {
    currentTb = topBanner[topBannerIdx];
  }
  let mbCls = needMb ? 'mb-[20px]' : 'mb-[0px]';
  if (currentTb?.backgroundLeftUrl) {
    mbCls = 'mb-[0px]';
  }
  return (
    <section
      className={`${mbCls} ${topBanner.length ? 'h-[60px]' : 'h-0'} relative m-auto max-w-[3840px] text-center transition-all duration-500 ${currentTb?.backgroundLeftUrl ? '' : 'contain-layout contain-style contain-paint'}`}
      data-spm="tb"
      aria-label="立创商城-营销图片专区"
    >
      <a
        className={`transition-backgroundImage mx-auto flex h-[60px] w-full items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat duration-500`}
        style={{
          backgroundImage: currentTb?.advertisingUrl && `url(${currentTb?.advertisingUrl})`,
        }}
        href={currentTb?.targetLink}
        title={currentTb?.title}
        target="_blank"
        onClick={handleClickTopBanner}
        data-spm={topBannerIdx + 1}
        key={topBannerIdx}
      >
        {/* <div
          className={`w-full h-full mx-auto bg-no-repeat bg-center bg-cover transition-backgroundImage duration-500`}
          style={{
            backgroundImage: `url(${currentTb?.advertisingUrl})`,
          }}
        ></div> */}
      </a>
      {currentTb?.backgroundLeftUrl && !isNeedTopAd && (
        <div
          className="absolute left-0 top-[60px] w-full overflow-hidden"
          style={{
            background: `url(${currentTb?.backgroundLeftUrl}) center center no-repeat`,
          }}
        >
          <img src={currentTb?.backgroundLeftUrl} alt="横幅背景图" className="invisible max-w-none" />
        </div>
      )}
      {(!currentTb?.backgroundLeftUrl || isNeedTopAd) && (
        <button
          className="absolute right-[50px] top-[10px] z-[6] size-[18px] bg-[url(https://static.szlcsc.com/ecp/assets/web/layout/head/images/close_top.png)] p-[4px] hover:opacity-50"
          onClick={closeTopBanner}
        ></button>
      )}
    </section>
  );
};

export default IndexTopBanner;
